import { useEffect } from "react"

export default function StripePaymentForm({ publishableKey, clientSecret }) {
  useEffect(() => {
    const runStripe = () => {
      const stripe = Stripe(publishableKey)
      const elements = stripe.elements()
      const cardElement = elements.create("card")

      cardElement.mount("#card-element")

      const $submitButton = $("#payment-form").find("button")

      cardElement.addEventListener("change", (event) => {
        const displayError = document.getElementById("stripe-card-errors")
        displayError.textContent = event.error ? event.error.message : ""
        $submitButton.prop("disabled", !event.complete)
      })

      const form = document.getElementById("payment-form")
      form.addEventListener("submit", (event) => {
        event.preventDefault()

        $submitButton.prop("disabled", true)
        $submitButton.prop("data-caption", $submitButton.text())
        $submitButton.html("Please wait...")

        stripe.handleCardSetup(clientSecret, cardElement).then((result) => {
          if (result.error) {
            const errorElement = document.getElementById("stripe-card-errors")
            errorElement.textContent = result.error.message
            $submitButton.prop("disabled", false)
            $submitButton.html($submitButton.prop("data-caption"))
          } else {
            const hiddenInput = document.createElement("input")
            hiddenInput.setAttribute("type", "hidden")
            hiddenInput.setAttribute("name", "stripeSetupIntent")
            hiddenInput.setAttribute("value", result.setupIntent.id)
            form.appendChild(hiddenInput)
            form.submit()
          }
        })
      })
    }

    let pollId
    if (typeof Stripe === "function") {
      runStripe()
    } else {
      pollId = setInterval(() => {
        if (typeof Stripe === "function") {
          runStripe()
          clearInterval(pollId)
        }
      }, 150)
    }

    return () => clearInterval(pollId)
  }, [publishableKey, clientSecret])

  return null
}
